<template>
  <el-dialog :visible.sync="dialogVisible" title="选择收单规则">
    <div class="rules-select-alert">
      <el-button class="mr-20" type="primary" @click="addRules">新增规则</el-button>
    </div>
    <div class="dia-w600 mt-30">
      <ul class="receipt-list" v-if="dataList.length > 0">
        <li v-for="(val, ind) in dataList" :key="ind">
          <div class="receipt-title">
            <span>{{ val.ruleName }}</span>
            <el-button class="mr-30" type="primary" size="small" @click="use(val)">使用</el-button>
          </div>
          <div class="receipt-item">
            <template v-for="item in val.constParams">
              <p v-if="item.value != 'null'" :key="item.name">{{ item.name }}：{{ item.text }}{{ item.valueUnit }}</p>
            </template>
          </div>
        </li>
      </ul>
      <div style="text-align: center" v-if="dataList.length == 0">暂无收单规则</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dataList: []
    };
  },
  created() {},
  methods: {
    addRules() {
      this.dialogVisible = false;
      window.open(`./settings.html#/companyRuleManage`);
    },
    showDialog(receiveRuleAllList) {
      this.dialogVisible = true;
      this.getRuleData(receiveRuleAllList);
    },
    getRuleData(receiveRuleAllList) {
      var arr = receiveRuleAllList || [];
      arr.forEach(item => {
        if (item.constParams) {
          item.constParams.forEach(val => {
            val.text = val.value;
            if (val.valueData) {
              var parseIntVal = parseInt(val.value);
              for (var key in val.valueData) {
                if (val.valueData[key] == parseIntVal) {
                  val.text = key;
                }
              }
            }
          });
        }
      });
      this.dataList = arr;
      console.log(this.dataList);
    },
    use(val) {
      this.dialogVisible = false;
      console.log('选择的值是', val);
      this.$emit('selectRules', val);
    }
  }
};
</script>
<style scoped>
.rules-select-alert {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.receipt-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 5px;
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: space-between;
}
.receipt-list li {
  border-bottom: 1px solid #e3e6e8;
  margin-bottom: 10px;
  padding-bottom: 15px;
}
.receipt-list li:last-child {
  border-bottom: none;
}
.receipt-item p {
  display: inline-block;
  width: 45%;
  padding-left: 5%;
  vertical-align: top;
}
.dia-w600 {
  height: 500px;
  overflow: scroll;
}
</style>
